var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagramShare(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "social 1",
    clipPath: "url(#clip0_367_30662)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 24C5.3736 24 0 18.6264 0 12C0 5.3736 5.3736 0 12 0C18.6264 0 24 5.3736 24 12C24 18.6264 18.6264 24 12 24Z",
    fill: "url(#paint0_linear_367_30662)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.0002 5.28484C14.1866 5.28484 14.4458 5.29204 15.3098 5.33284C16.109 5.36884 16.5434 5.50324 16.8314 5.61604C17.213 5.76484 17.4866 5.94244 17.7722 6.22804C18.0578 6.51364 18.2354 6.78724 18.3842 7.16884C18.497 7.45684 18.629 7.89124 18.6674 8.69044C18.7058 9.55444 18.7154 9.81364 18.7154 12C18.7154 14.1864 18.7082 14.4456 18.6674 15.3096C18.6314 16.1088 18.497 16.5432 18.3842 16.8312C18.2354 17.2128 18.0578 17.4864 17.7722 17.772C17.4866 18.0576 17.213 18.2352 16.8314 18.384C16.5434 18.4968 16.109 18.6288 15.3098 18.6672C14.4458 18.7056 14.1866 18.7152 12.0002 18.7152C9.81384 18.7152 9.55464 18.708 8.69064 18.6672C7.89144 18.6312 7.45704 18.4968 7.16904 18.384C6.78744 18.2352 6.51384 18.0576 6.22824 17.772C5.94264 17.4864 5.76504 17.2128 5.61624 16.8312C5.50344 16.5432 5.37144 16.1088 5.33304 15.3096C5.29464 14.4456 5.28504 14.1864 5.28504 12C5.28504 9.81364 5.29224 9.55444 5.33304 8.69044C5.36904 7.89124 5.50344 7.45684 5.61624 7.16884C5.76504 6.78724 5.94264 6.51364 6.22824 6.22804C6.51384 5.94244 6.78744 5.76484 7.16904 5.61604C7.45704 5.50324 7.89144 5.37124 8.69064 5.33284C9.55464 5.29204 9.81384 5.28484 12.0002 5.28484ZM12.0002 3.80884C9.77544 3.80884 9.49704 3.81844 8.62344 3.85924C7.75224 3.90004 7.15704 4.03684 6.63384 4.24084C6.09624 4.44724 5.63784 4.72804 5.18424 5.18404C4.72824 5.64004 4.44984 6.09604 4.23864 6.63604C4.03704 7.15684 3.89784 7.75204 3.85704 8.62564C3.81624 9.49924 3.80664 9.77764 3.80664 12.0024C3.80664 14.2272 3.81624 14.5056 3.85704 15.3792C3.89784 16.2504 4.03464 16.8456 4.23864 17.3688C4.44744 17.904 4.72824 18.3624 5.18424 18.816C5.64024 19.272 6.09624 19.5504 6.63624 19.7616C7.15704 19.9632 7.75224 20.1024 8.62584 20.1432C9.49944 20.184 9.77784 20.1936 12.0026 20.1936C14.2274 20.1936 14.5058 20.184 15.3794 20.1432C16.2506 20.1024 16.8458 19.9656 17.369 19.7616C17.9042 19.5528 18.3626 19.272 18.8162 18.816C19.2722 18.36 19.5506 17.904 19.7618 17.364C19.9634 16.8432 20.1026 16.248 20.1434 15.3744C20.1842 14.5008 20.1938 14.2224 20.1938 11.9976C20.1938 9.77284 20.1842 9.49444 20.1434 8.62084C20.1026 7.74964 19.9658 7.15444 19.7618 6.63124C19.553 6.09604 19.2722 5.63764 18.8162 5.18404C18.3602 4.72804 17.9042 4.44964 17.3642 4.23844C16.8434 4.03684 16.2482 3.89764 15.3746 3.85684C14.5034 3.81844 14.225 3.80884 12.0002 3.80884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.0002 7.79285C9.67697 7.79285 7.79297 9.67685 7.79297 12C7.79297 14.3232 9.67697 16.2072 12.0002 16.2072C14.3234 16.2072 16.2074 14.3232 16.2074 12C16.2074 9.67685 14.3234 7.79285 12.0002 7.79285ZM12.0002 14.7312C10.493 14.7312 9.26897 13.5096 9.26897 12C9.26897 10.4904 10.493 9.26885 12.0002 9.26885C13.5074 9.26885 14.7314 10.4904 14.7314 12C14.7314 13.5096 13.5074 14.7312 12.0002 14.7312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.3732 8.61119C16.9166 8.61119 17.3572 8.17064 17.3572 7.62719C17.3572 7.08374 16.9166 6.64319 16.3732 6.64319C15.8297 6.64319 15.3892 7.08374 15.3892 7.62719C15.3892 8.17064 15.8297 8.61119 16.3732 8.61119Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_367_30662",
    x1: 3.51473,
    y1: 20.4853,
    x2: 20.4853,
    y2: 3.51473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0551048,
    stopColor: "#FFD020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1241,
    stopColor: "#FEC01E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2004,
    stopColor: "#FCA71B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    stopColor: "#FA8316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3681,
    stopColor: "#F85510"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4563,
    stopColor: "#F51E09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F30005"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5035,
    stopColor: "#F20007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5966,
    stopColor: "#E1003B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6879,
    stopColor: "#D30067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7757,
    stopColor: "#C70088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8589,
    stopColor: "#BF00A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9357,
    stopColor: "#BB00AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B900B4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_367_30662"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramShare);
export default __webpack_public_path__ + "static/media/instagramShare.9007f14758eeaf9102765711df527c4c.svg";
export { ForwardRef as ReactComponent };